import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-591eda1b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "header headline3 m-5 border-none"
}
const _hoisted_2 = { class: "mt-auto" }

import { strapiUrl } from "@/api/api";
import AButton from "@/components/Base/AButton.vue";
import AImage from "@/components/Base/AImage.vue";
import Toolbar from "@/components/Navigation/Toolbar";
import { PredefinedGeometry } from "@/composables/Map/useDraw";
import useScreenSize from "@/composables/useScreenSize";
import { useStore } from "@/composables/useTypedStore";
import { IonButton, IonButtons, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonPage, IonRow, modalController } from '@ionic/vue';
import { arrowBack } from 'ionicons/icons';
import { computed, PropType, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PredefinedGeometriesModal',
  props: {
  geometries: {
    type: Object as PropType<Record<string, PredefinedGeometry[]>>,
    required: true
  }
},
  setup(__props) {

const props = __props;

const selectedGeometry = ref<PredefinedGeometry | null>(null);



const store = useStore();
const { isMaxXSmall } = useScreenSize();

const isMobile = computed(() => {
  return store.getters["app/isMobile"];
});

//helper until tabs are implemented
const flatGeometries = computed(() => {
  return Object.values(props.geometries).flat();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      (isMobile.value)
        ? (_openBlock(), _createBlock(_unref(IonHeader), { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_unref(Toolbar), {
                title: _ctx.$t('appmap.selectGeometry')
              }, {
                leading: _withCtx(() => [
                  _createVNode(_unref(IonButtons), { slot: "start" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonButton), {
                        slot: "start",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(modalController).dismiss()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), { icon: _unref(arrowBack) }, null, 8, ["icon"]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("buttons.zurueck")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["title"])
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t('appmap.selectGeometry')), 1)),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonGrid), { class: "mt-4 ml-5" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(flatGeometries.value, (geometry) => {
                    return (_openBlock(), _createBlock(_unref(IonCol), {
                      key: geometry.name,
                      size: _unref(isMaxXSmall) ? '12' : '4',
                      class: "cursor-pointer",
                      onClick: ($event: any) => (selectedGeometry.value = geometry)
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["flex flex-col gap-4 h-full items-center p-2 rounded-lg", { 'bg-gray-200': selectedGeometry.value?.name === geometry.name }])
                        }, [
                          _createVNode(AImage, {
                            src: `${_unref(strapiUrl)}/${geometry.imageUrl}`,
                            "image-class": _unref(isMaxXSmall) ? 'h-full' : 'w-32'
                          }, null, 8, ["src", "image-class"]),
                          _createElementVNode("span", _hoisted_2, _toDisplayString(geometry.name), 1)
                        ], 2)
                      ]),
                      _: 2
                    }, 1032, ["size", "onClick"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", {
            class: _normalizeClass(["my-8 flex gap-4", _unref(isMaxXSmall) ? 'flex-col mx-8' : 'flex-row mr-4 justify-end'])
          }, [
            _createVNode(AButton, {
              disabled: selectedGeometry.value ? false : true,
              "btn-primary": true,
              class: "px-16 py-6 text-lg",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(modalController).dismiss(selectedGeometry.value)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(`buttons.insert`)), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(AButton, {
              "btn-secondary": true,
              class: "px-16 py-6 text-lg",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(modalController).dismiss()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('hzba.buttons.abbrechen')), 1)
              ]),
              _: 1
            })
          ], 2)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})